import { LottieLoader } from '../../LottieLoader';
import styles from './PageLoader.module.css';

// One centered loader that holds a screen's content area while its primary reads are in
// flight, so the whole screen appears at once instead of assembling piece by piece — the
// same reasoning `SettingsLoader` documents, as a primitive any screen can reach.
//
// The mark is the branded Symphony loop (`LottieLoader`) — the same animation the dashboard
// wait draws — rather than a bare spinner, so every page-level wait in the app is one
// consistent, branded loop. `LottieLoader` carries its own `role="status"` + label.
export function PageLoader({ size = 96 }: { size?: number } = {}) {
  return (
    <div className={styles.loader}>
      <LottieLoader size={size} />
    </div>
  );
}
